export * as DomTools from "./dom.tools";